<template>
  <div>
    <headerTop></headerTop>
    <div class="wrapper">
      <!-- 极配正品 -->
      <!-- <div class="header">
        <img src="@/assets/images/home/logo.png" class="logo" alt="" />
        <div style="position: relative;">
          <div style=" position: absolute;bottom: 0;right: 0; width: 135px;">
            正见 &nbsp; •&nbsp;&nbsp;正心&nbsp; •&nbsp;&nbsp;正品
          </div>
        </div>
      </div> -->
      <div class="content_button">
        <!-- 进度 -->
        <div class="flow">
          <div class="flowcontent">
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-zu5361"></i> -->
                <img src="@/assets/images/refund/组 706.png" alt="" />
              </div>
              <div>买家申请售后</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan35"></i> -->
                <img src="@/assets/images/refund/组 1567.png" alt="" />
              </div>
              <div class="finish">卖家处理售后申请</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan38"></i> -->
                <img src="@/assets/images/refund/组 1612.png" alt="" />
              </div>
              <div>售后处理完毕</div>
            </div>
            <!-- <div>
              <div></div>
              <div>买家申请退货退货</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" />
            <div>
              <div></div>
              <div>买家申请退货退货</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" /> -->
          </div>
        </div>
        <div class="tk">
          <!-- 详情 -->
          <div class="testimony">
            <!-- 退货 -->
            <div class="dispose">
              <div class="tytk" v-if="information.refundState == 4">
                <span class="iconfont icon-tongyihuanhuo"></span>
              </div>
              <div class="tytk" v-if="information.refundState == 2">
                <img class="imgs9" src="@/assets/images/组 1595.png" alt="" />
              </div>
              <p v-if="information.role == 1 && information.refundState == 4 &&information.type == 2">
                卖家同意退货,退货金额
                <span style="color: #e90d0d; margin-left: 4px"
                  >&yen;{{ refundindent.goodsAmount }}</span
                >
              </p>
                <p v-if="information.role == 1 && information.refundState == 4 &&information.type == 3">
                卖家同意退款,退款金额
                <span style="color: #e90d0d; margin-left: 4px"
                  >&yen;{{ refundindent.goodsAmount }}</span
                >
              </p>
              <p v-if="information.role == 1 && information.refundState == 2">
                卖家拒绝退货
              </p>
              <p v-if="information.role == 2 && information.refundState == 2 &&information.type == 3">
                拒绝退款
              </p>
              <p v-if="information.role == 2 && information.refundState == 2 &&information.type == 2">
                拒绝退货退款
              </p>
              <p v-if="information.role == 1 && information.refundState == 3">
                已撤销
              </p>
              <p v-if="information.role == 2 && information.refundState == 3">
                买家已撤销
              </p>
              <p v-if="information.role == 2 && information.refundState == 4 &&information.type == 2">
                同意退货,退货金额
                <span style="color: #e90d0d; margin-left: 4px"
                  >&yen;{{ refundindent.goodsAmount }}</span
                >
              </p>
              <p v-if="information.role == 2 && information.refundState == 4 &&information.type == 3">
                同意退款,退款金额
                <span style="color: #e90d0d; margin-left: 4px"
                  >&yen;{{ refundindent.goodsAmount }}</span
                >
              </p>
            </div>
            <!-- 表单 -->
            <div class="Sheets">
              <Row>
                <Col span="5">
                  <span>服务类型 :</span>
                  <!-- <span>{{}}</span> -->
                  <span style="margin-left: 5px">{{
                    information.type == 3 ? '仅退款' : '退货退款'
                  }}</span>
                </Col>
                <Col span="12">
                  <span>原因 :</span>
                  <span style="margin-left: 5px">{{
                    information.content
                  }}</span>
                </Col>
              </Row>
              <!-- <Row>
              <Col span="12">
                <span>退货说明 :</span>
                <span style="margin-left:5px">{{ information.remark }}</span>
              </Col>
            </Row> -->
              <div class="explain">
                <div class="w64">退款说明 :</div>
                <div class="smcontent">
                  <span style="margin-left: 5px">{{ information.remark }}</span>
                </div>
              </div>
              <Row>
                <Col style="margin-top: 8px">
                  <div style="display: flex">
                    <div>上传凭证 :</div>
                    <ul>
                      <li v-viewer>
                        <img
                          v-for="item in voucherlist"
                          :key="item"
                          :src="item"
                          alt=""
                        />
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
            <!-- 表格 -->
            <div class="sheet">
              <span class="returns"> 退货商品:</span>
              <vxe-table
                border
                ref="xTable3"
                size="mini"
                align="center"
                resizable
                show-overflow
                :data="tableData3"
              >
                <vxe-column
                  field="partName"
                  title="退货商品"
                  width="220"
                ></vxe-column>
                <vxe-column field="partName" title="发货地" width="220">
                  <template #default="{ row }">
                    <span> {{ row.shipCity }}{{ row.shipStore }} </span>
                  </template>
                </vxe-column>
                <vxe-column
                  field="partNum"
                  title="购买数量"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundableAmount"
                  title="可退数量"
                  width="100"
                ></vxe-column>
                <vxe-column field="refundNumber" title="退货数量" width="120">
                </vxe-column>
                <vxe-column
                  field="refundPrice"
                  title="退货单价"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundAmount"
                  title="退货金额"
                  width="100"
                ></vxe-column>
              </vxe-table>
            </div>
          </div>

          <!-- 订单详情 -->
          <div class="indentparticulars">
            <div class="headline">
              <span>订单详情</span>
            </div>
            <div class="content">
              <div class="content_top">
                <Row>
                  <Col span="6">
                    <span>卖家 :&nbsp;</span>
                    <span>{{ particulars.buyShopName }}</span>
                    <span v-if="information.role == 1">
                      <xiaopei
                        :oppositeTenantId="particulars.buyTenantId"
                        :orderId="information.afterSaleId"
                      >
                        <i class="iconfont icon-a-lujing162"></i> </xiaopei
                    ></span>
                  </Col>
                  <Col span="6">
                    <span>订单编号 :&nbsp;</span>
                    <span class="span1">
                      <router-link
                        rel="opener"
                        :to="{
                          path: '/orderDetails',
                          query: {
                            id: particulars.code,
                            orderId: particulars.id
                          }
                        }"
                        >{{ particulars.code }}</router-link
                      >
                    </span>
                  </Col>
                  <Col span="6">
                    <span>商品金额 :&nbsp;</span>
                    <span style="margin-left: 5px"
                      >&yen;{{ particulars.goodsAmount }}</span
                    >
                  </Col>
                </Row>

                <div style="margin-top: 40px">
                  <Row>
                    <Col span="6">
                      <span>运费 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{
                          particulars.freight ? particulars.freight : 0
                        }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>实付款 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ particulars.payMoney }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>数量 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        particulars.count
                      }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
              <div class="details">
                <div class="cleared">
                  <Row>
                    <Col span="6">
                      <span>退货单号 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        refundindent.code
                      }}</span>
                    </Col>
                    <Col span="6">
                      <span>服务类型 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        refundindent.type == '2' ? '退货退款' : '仅退款'
                      }}</span>
                    </Col>

                    <Col span="6">
                      <span>退货金额 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ refundindent.goodsAmount }}</span
                      >
                    </Col>
                  </Row>
                  <Row style="margin-top: 33px">
                    <Col span="6">
                      <span>状态 :&nbsp;</span>
                      <span class="colorFF6">{{ information.orderState }}</span>
                    </Col>
                    <Col span="6">
                      <span>退货数量 :&nbsp;</span>
                      <span>{{ refundindent.count }}</span>
                    </Col>
                    <Col span="6">
                      <span>原因 :&nbsp;</span>
                      <span>{{ information.content }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
import { disfreightInfo } from '@/api/freight/index'
import xiaopei from '@/views/xiaopei/index.vue'
export default {
  components: {
    headerTop,
    xiaopei
  },
  props: {
    afterSaleId: String,
    refundType: String
    // finish: String
  },
  data() {
    return {
      examine: false,
      sellerconsent: true, // 卖家同意
      sellerrefuse: false, // 卖家拒绝
      // 第二个表格数据
      tableData3: [
        // {
        //   id: 10001,
        //   partsName: '奔驰水箱散热器A1695001803', // 配件名称
        //   buyquantity: '购买数量', // 购买数量
        //   returnable: '可退数量', // 可退数量
        //   returns: '退货数量', // 退货数量
        //   returnsprice: '退货单价', // 退货单价
        //   returnsmoney: '退货金额' // 退货金额
        // }
      ],
      voucherlist: [
        // {
        //   id: '1',
        //   logo:
        //     'https://img2.baidu.com/it/u=349145238,254936008&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=400'
        // },
        // {
        //   id: '2',
        //   logo:
        //     'https://img2.baidu.com/it/u=349145238,254936008&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=400'
        // }
      ], // 长传凭证的照片
      refundindent: {}, // 退货订单
      information: {}, // 原因
      particulars: {}, // 订单详情普通订单
      dt: ''
    }
  },
  created() {
    this.orderdata3()
  },
  methods: {
    // 退货退货详情
    async orderdata3() {
      console.log('---orderData:', this.afterSaleId)
      const res = await disfreightInfo(this.afterSaleId + '/' + this.refundType)
      console.log(res)
      this.information = res.data
      this.voucherlist = res.data.imagesUrl
      this.tableData3 = res.data.ordersDetailVOList
      this.refundindent = res.data.refundOrderVO
      this.particulars = res.data.orderVO
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
